import _ = require('underscore');

import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { isAnyItemFlowSubscription } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { changeSubscriptionsFrequency } from '../actions/SubscriptionsActions';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';

export const ChangeSubscriptionsFrequencyEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeFrequency,
  translateName: Messages.changeSubscriptionsFrequency_action,
  isVisible: (subscriptions) => !isAnyItemFlowSubscription(subscriptions),
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionsFrequency(subscriptions)
};
